import { useMemo } from "react";
import { useDeviceIdentity } from "./useDeviceIdentity";

export const DEVICE_CASH_SESSION_MESSAGES = {
  device_missing: "This device is not paired. Please pair the device to continue.",
  no_session: "No active till session is mapped to this POS device.",
  multiple_sessions:
    "Multiple open till sessions are mapped to this POS device. Please contact support or admin.",
};

export const normalizeDeviceName = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  return raw
    .replace(/[_\s]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
};

export const resolveDeviceCashSession = (openSessions, device) => {
  const sessions = Array.isArray(openSessions) ? openSessions : [];
  const deviceIdentifiers = [
    device?.deviceName,
    device?.deviceKey,
    device?.deviceId,
    localStorage.getItem("edgeDeviceName"),
    localStorage.getItem("edgeDeviceToken"),
    process.env.REACT_APP_DEVICE_NAME,
    process.env.REACT_APP_DEVICE_KEY,
    process.env.REACT_APP_DEVICE_TOKEN,
  ]
    .map((value) => normalizeDeviceName(value))
    .filter(Boolean);

  if (deviceIdentifiers.length === 0) {
    return {
      status: "device_missing",
      message: DEVICE_CASH_SESSION_MESSAGES.device_missing,
      matchedSessions: [],
      selectedSession: null,
      selectedSessionId: "",
    };
  }

  const matchedSessions = sessions.filter(
    (session) => {
      const sessionIdentifiers = [
        session?.deviceName,
        session?.deviceKey,
        session?.deviceToken,
        session?.deviceId,
        session?.tillName,
        session?.tillCode,
      ]
        .map((value) => normalizeDeviceName(value))
        .filter(Boolean);

      return sessionIdentifiers.some((identifier) =>
        deviceIdentifiers.includes(identifier),
      );
    },
  );

  if (matchedSessions.length === 1) {
    const selectedSession = matchedSessions[0];
    return {
      status: "ready",
      message: "",
      matchedSessions,
      selectedSession,
      selectedSessionId: String(selectedSession?.cashSessionId || ""),
    };
  }

  if (matchedSessions.length === 0) {
    return {
      status: "no_session",
      message: DEVICE_CASH_SESSION_MESSAGES.no_session,
      matchedSessions,
      selectedSession: null,
      selectedSessionId: "",
    };
  }

  return {
    status: "multiple_sessions",
    message: DEVICE_CASH_SESSION_MESSAGES.multiple_sessions,
    matchedSessions,
    selectedSession: null,
    selectedSessionId: "",
  };
};

export const useDeviceCashSessionResolution = (openSessions, enabled = true) => {
  const deviceQuery = useDeviceIdentity(enabled);

  const resolution = useMemo(
    () => resolveDeviceCashSession(openSessions, deviceQuery.device),
    [openSessions, deviceQuery.device],
  );

  return {
    ...deviceQuery,
    ...resolution,
  };
};
